import { render, staticRenderFns } from "./koppeling.vue?vue&type=template&id=52eee3be&scoped=true"
import script from "./koppeling.vue?vue&type=script&lang=js"
export * from "./koppeling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52eee3be",
  null
  
)

export default component.exports